export interface GameItem {
  slug: string;
  title: string;
  shortTitle: string;
  category: string;
  platform: string[];
  tags: string[];
  size: string;
  version: string;
  update: string;
  hot: number;
  rating: number;
  downloads: string;
  cover: string;
  intro: string;
  description: string[];
  features: string[];
  requirements: string[];
  steps: string[];
  official: boolean;
  noInstall: boolean;
}

export const games: GameItem[] = [
  {
    slug: "huoying-zhan-chang",
    title: "火影战场·木叶忍战（手机版）",
    shortTitle: "火影战场",
    category: "手机版",
    platform: ["Android", "iOS"],
    tags: ["格斗", "横版", "竞技"],
    size: "812MB",
    version: "v3.2.1",
    update: "2026.08",
    hot: 98,
    rating: 4.8,
    downloads: "128万",
    cover: "https://readdy.ai/api/search-image?query=A%20dynamic%20anime%20style%20fighting%20game%20cover%20art%20featuring%20young%20ninjas%20in%20orange%20and%20black%20attire%20in%20combat%20poses%20on%20a%20village%20rooftop%20at%20dusk%2C%20vibrant%20orange%20glow%20and%20fire%20effects%2C%20energetic%20and%20epic%2C%20high%20detail%20digital%20painting&width=800&height=600&seq=game-cover-battlefield&orientation=landscape",
    intro: "一款主打横版格斗对战的同人游戏，还原原著经典招式连段，支持实时在线对战与段位匹配。",
    description: [
      "火影战场·木叶忍战是一款以横版格斗为核心的同人对战游戏，将原著中耳熟能详的忍术与体术还原到快节奏的连段对抗中。游戏针对手机触屏做了深度优化，虚拟摇杆与技能键位可自定义布局，连招出招手感流畅。",
      "游戏内置排位赛、好友约战、剧情挑战与无尽模式四种玩法。你可以用查克拉资源打出华丽的奥义连段，也可以利用替身术与瞬身走位创造反杀机会。每场对局节奏紧凑，平均三分钟一局，很适合通勤碎片时间。",
      "画面采用高饱和度的卡通渲染风格，配合忍术爆发的粒子特效与音效反馈，让每一击都拳拳到肉。数据实时云端同步，多端进度互通。",
    ],
    features: [
      "高度还原原著角色招式与奥义演出",
      "实时在线对战与赛季段位系统",
      "可自定义的虚拟摇杆与按键布局",
      "剧情、排位、约战、无尽四模式",
      "云存档，多设备进度同步",
    ],
    requirements: [
      "系统要求：Android 7.0 及以上 / iOS 12 及以上",
      "运行内存：4GB 及以上",
      "存储空间：预留 1.5GB",
      "网络：支持在线对战需稳定网络",
    ],
    steps: [
      "点击页面下载按钮获取安装包（安卓为 APK，苹果端走 TestFlight 安装）。",
      "若系统提示未知来源，请在设置中允许安装来自此来源的应用。",
      "安装完成后首次打开需下载约 300MB 资源包，请连接 Wi-Fi。",
      "注册账号或游客登录即可进入游戏。",
    ],
    official: false,
    noInstall: false,
  },
  {
    slug: "renzhe-rongyu",
    title: "忍者荣耀·疾风传（电脑版）",
    shortTitle: "忍者荣耀",
    category: "电脑版",
    platform: ["Windows", "macOS"],
    tags: ["动作", "开放世界", "单机"],
    size: "3.8GB",
    version: "v1.6.0",
    update: "2026.08",
    hot: 95,
    rating: 4.7,
    downloads: "86万",
    cover: "https://readdy.ai/api/search-image?query=Epic%20anime%20style%20open%20world%20game%20key%20art%20with%20a%20young%20ninja%20in%20orange%20jacket%20standing%20before%20a%20grand%20ninja%20village%20at%20golden%20hour%2C%20warm%20orange%20and%20amber%20sky%2C%20epic%20scale%2C%20detailed%20digital%20painting%2C%20cinematic%20lighting&width=800&height=600&seq=game-cover-glory&orientation=landscape",
    intro: "开放世界动作单机同人作品，可自由探索五大忍村，完成主线剧情与支线任务。",
    description: [
      "忍者荣耀·疾风传是一款开放世界动作单机同人游戏，以广阔的忍界大陆为舞台。你可以自由穿梭于木叶、砂隐等村镇之间，接取任务、挑战忍者、收集卷轴，逐步揭开原创剧情线。",
      "战斗系统融合了体术连招、忍术切换与通灵召唤，配合查克拉管理系统，让每一场战斗都充满策略。装备与技能树可自由搭配，走出属于自己的忍者道路。",
      "游戏内置拍照模式与天气系统，日落时分站在崖顶俯瞰木叶全貌，是很多玩家最爱的一刻。存档本地化，断网也能畅玩。",
    ],
    features: [
      "可自由探索的开放忍界大地图",
      "原创剧情主线与海量支线任务",
      "体术、忍术、通灵三系战斗组合",
      "技能树与装备自由养成",
      "本地存档，离线可玩",
    ],
    requirements: [
      "系统要求：Windows 10 及以上 / macOS 11 及以上",
      "处理器：Intel i5 或同级以上",
      "内存：8GB 及以上",
      "显卡：GTX 1050 或同级以上",
    ],
    steps: [
      "下载页面提供的压缩包（Win 为 zip，Mac 为 dmg）。",
      "解压到任意磁盘目录，路径避免出现中文。",
      "运行目录内的启动器文件开始游戏。",
      "首次运行会自动生成存档与设置文件。",
    ],
    official: false,
    noInstall: false,
  },
  {
    slug: "muye-yingxiong",
    title: "木叶英雄·热血格斗（安卓版）",
    shortTitle: "木叶英雄",
    category: "安卓版",
    platform: ["Android"],
    tags: ["格斗", "竖屏", "休闲"],
    size: "468MB",
    version: "v5.0.3",
    update: "2026.07",
    hot: 92,
    rating: 4.6,
    downloads: "203万",
    cover: "https://readdy.ai/api/search-image?query=Bright%20and%20playful%20anime%20style%20mobile%20fighting%20game%20art%20with%20chibi%20ninja%20characters%20in%20orange%20and%20teal%20outfits%20doing%20energy%20attacks%2C%20cheerful%20warm%20tones%2C%20clean%20and%20colorful%2C%20high%20quality%20digital%20illustration&width=800&height=600&seq=game-cover-hero&orientation=landscape",
    intro: "竖屏休闲格斗同人游戏，单手即可操作，碎片时间轻松上手，卡通画风可爱讨喜。",
    description: [
      "木叶英雄·热血格斗是一款竖屏休闲格斗同人游戏，主打单手操作与快速对战。屏幕下方三个技能按键，点击即可释放忍术，滑动进行闪避，轻松打出华丽连招。",
      "游戏包含闯关模式、日常挑战与竞技场。角色可通过碎片升星，技能随星级解锁。整体节奏轻快，无需复杂教学，几分钟就能上手。",
      "画风采用明亮卡通渲染，角色形象 Q 版可爱，技能特效色彩丰富，配合欢快的背景音乐，非常适合休闲玩家。",
    ],
    features: [
      "竖屏单手操作，轻松易上手",
      "Q 版卡通角色与多彩技能特效",
      "闯关、竞技场、日常挑战玩法",
      "角色碎片收集与升星养成",
      "离线挂机收益",
    ],
    requirements: [
      "系统要求：Android 6.0 及以上",
      "运行内存：3GB 及以上",
      "存储空间：预留 1GB",
    ],
    steps: [
      "下载 APK 安装包（约 468MB）。",
      "允许安装未知来源应用后完成安装。",
      "首次启动下载少量资源包即可游玩。",
    ],
    official: false,
    noInstall: false,
  },
  {
    slug: "rendao-zoulang",
    title: "忍道走廊·汉化收藏版",
    shortTitle: "忍道走廊",
    category: "汉化版",
    platform: ["Android", "Windows"],
    tags: ["RPG", "回合制", "汉化"],
    size: "1.2GB",
    version: "v2.4 汉化",
    update: "2026.06",
    hot: 88,
    rating: 4.5,
    downloads: "57万",
    cover: "https://readdy.ai/api/search-image?query=Story%20driven%20anime%20RPG%20game%20art%20with%20ninja%20team%20walking%20through%20a%20traditional%20japanese%20corridor%20with%20paper%20lanterns%2C%20warm%20amber%20and%20orange%20lighting%2C%20atmospheric%20and%20immersive%2C%20detailed%20digital%20illustration&width=800&height=600&seq=game-cover-corridor&orientation=landscape",
    intro: "知名日文同人 RPG 的完整汉化版本，全文本剧情精翻，新手引导与菜单全面中文化。",
    description: [
      "忍道走廊·汉化收藏版是一款来自同人社团的回合制 RPG 作品，本次提供完整汉化版本。游戏以原创剧情为主，讲述年轻忍者追寻忍道真相的成长故事。",
      "汉化组对全文本剧情进行了精翻润色，对话、菜单、技能说明、任务提示均实现中文化，方便国内玩家完整体验。包含大量隐藏剧情与多结局设定。",
      "战斗为经典回合制，角色各具特色，忍术与装备搭配空间大。通关后解锁二周目挑战与真结局。",
    ],
    features: [
      "全文本精翻完整汉化",
      "原创剧情与多结局设定",
      "经典回合制战斗与装备搭配",
      "大量隐藏要素与二周目内容",
      "兼容手机与电脑双平台",
    ],
    requirements: [
      "手机版：Android 8.0 及以上，4GB 内存",
      "电脑版：Windows 10 及以上，8GB 内存",
      "分辨率：1280×720 及以上",
    ],
    steps: [
      "选择对应平台的安装包下载。",
      "安卓直接安装；电脑解压后运行启动器。",
      "汉化文件已内置，无需额外覆盖。",
    ],
    official: false,
    noInstall: false,
  },
  {
    slug: "renjie-hengji",
    title: "忍界横击·免安装版",
    shortTitle: "忍界横击",
    category: "免安装版",
    platform: ["Windows"],
    tags: ["动作", "横版", "免安装"],
    size: "2.1GB",
    version: "绿色版",
    update: "2026.05",
    hot: 85,
    rating: 4.6,
    downloads: "43万",
    cover: "https://readdy.ai/api/search-image?query=Fast%20paced%20side%20scrolling%20action%20game%20art%20with%20ninja%20running%20across%20rooftops%20at%20night%20under%20orange%20moonlight%2C%20dynamic%20motion%20blur%2C%20warm%20and%20moody%20tones%2C%20high%20detail%20digital%20painting&width=800&height=600&seq=game-cover-instant&orientation=landscape",
    intro: "绿色免安装动作游戏，解压即玩无需配置，适合想快速体验的玩家。",
    description: [
      "忍界横击·免安装版是一款横版动作同人游戏，主打绿色免安装体验。下载压缩包后直接解压到磁盘，双击运行即可进入游戏，无需安装与额外配置，方便快捷。",
      "玩法以高速跑酷与连招战斗为主，玩家操控角色在屋顶与街道间穿梭，击败沿途敌人并挑战关卡 BOSS。操作反馈灵敏，打击感扎实。",
      "游戏体积经过精简优化，即使配置一般的电脑也能流畅运行，是体验横版同人动作的轻量之选。",
    ],
    features: [
      "绿色免安装，解压即玩",
      "高速横版跑酷与连招战斗",
      "关卡制与 BOSS 挑战",
      "配置要求低，运行流畅",
    ],
    requirements: [
      "系统要求：Windows 10 及以上",
      "内存：4GB 及以上",
      "显卡：集显即可流畅运行",
    ],
    steps: [
      "下载压缩包（约 2.1GB）。",
      "解压到磁盘根目录，路径避免中文。",
      "双击目录内主程序直接开始游戏。",
    ],
    official: false,
    noInstall: true,
  },
  {
    slug: "huoying-shida",
    title: "火影世代·守护忍村",
    shortTitle: "火影世代",
    category: "手机版",
    platform: ["Android", "iOS"],
    tags: ["策略", "塔防", "卡牌"],
    size: "688MB",
    version: "v2.8.0",
    update: "2026.06",
    hot: 82,
    rating: 4.4,
    downloads: "64万",
    cover: "https://readdy.ai/api/search-image?query=Strategy%20tower%20defense%20anime%20game%20art%20with%20a%20ninja%20village%20under%20attack%20defended%20by%20colorful%20ninja%20units%2C%20warm%20orange%20and%20brown%20palette%2C%20epic%20battlefield%20at%20sunset%2C%20detailed%20digital%20illustration&width=800&height=600&seq=game-cover-generation&orientation=landscape",
    intro: "策略塔防同人手游，布阵防守忍村，抵御一波波来犯之敌，考验排兵布阵。",
    description: [
      "火影世代·守护忍村是一款策略塔防同人手游。玩家需要消耗查克拉在道路上布置忍者单位，抵御一波波敌人的进攻，保护忍村核心不被突破。",
      "忍者单位分为输出、坦克、辅助等多种定位，可通过升级与技能强化提升战力。合理的站位与技能时机是取胜关键，关卡设计层层递进。",
      "除主线关卡外，还有限时活动与每日挑战，奖励丰富。画风明亮精致，战斗特效华丽，节奏适中。",
    ],
    features: [
      "策略塔防与布阵玩法",
      "多定位忍者单位与技能养成",
      "主线关卡、限时活动、每日挑战",
      "明亮精致的卡通风画面",
    ],
    requirements: [
      "系统要求：Android 7.0 及以上 / iOS 12 及以上",
      "运行内存：3GB 及以上",
      "存储空间：预留 1.2GB",
    ],
    steps: [
      "下载对应平台安装包。",
      "完成安装后进入游戏。",
      "跟随新手引导完成首场防守战。",
    ],
    official: false,
    noInstall: false,
  },
];

export const platformCategories = [
  {
    key: "shouji",
    name: "手机版",
    desc: "安卓与 iOS 双端适配的同人手游",
    icon: "ri-smartphone-line",
  },
  {
    key: "diannao",
    name: "电脑版",
    desc: "Windows 与 macOS 平台的 PC 同人作品",
    icon: "ri-computer-line",
  },
  {
    key: "anzhuo",
    name: "安卓版",
    desc: "专为安卓系统优化安装包",
    icon: "ri-android-line",
  },
  {
    key: "hanhua",
    name: "汉化版",
    desc: "完整中文化的日文同人作品",
    icon: "ri-translate-2",
  },
  {
    key: "miananzhuang",
    name: "免安装版",
    desc: "绿色免安装，解压即玩",
    icon: "ri-flashlight-fill",
  },
];

export const faqs = [
  {
    q: "火影同人游戏和官方手游有什么区别？",
    a: "同人游戏是玩家或制作组基于火影世界观自发创作的免费作品，风格和玩法更自由，常见有格斗、RPG、塔防等类型，与官方商业手游不同，通常免费提供。本站仅整理这些同人资源的下载指引。",
  },
  {
    q: "安卓手机下载安装包时提示未知来源怎么办？",
    a: "这是系统的正常安全提示。你可以在系统设置里允许“安装来自此来源的应用”，或根据手机品牌在安装弹窗中勾选允许后继续安装。本站提供的安装包均经过整理校验，但下载后建议先杀毒再安装。",
  },
  {
    q: "免安装版和正式安装版有什么区别？",
    a: "免安装版（绿色版）无需执行安装程序，解压后双击即可运行，适合快速体验或配置较低的环境；正式安装版会写入程序目录并生成快捷方式。两者内容基本一致，按你的使用习惯选择即可。",
  },
  {
    q: "电脑版游戏解压后打不开怎么办？",
    a: "请确认解压路径中没有中文或特殊字符，并检查是否满足游戏的系统与显卡要求。若仍无法启动，可尝试右键以管理员身份运行，或更新显卡驱动后重试。",
  },
  {
    q: "汉化版需要额外打补丁吗？",
    a: "本站提供的汉化版已将汉化文件内置整合，下载安装后即可直接显示中文，无需额外覆盖或打补丁。如果个别版本后续更新，会在资源页标注说明。",
  },
  {
    q: "手机版和电脑版存档可以互通吗？",
    a: "多数单机同人游戏采用本地存档，手机与电脑存档默认不互通。部分支持云存档的在线同人手游可以在登录同一账号后多端同步，具体以游戏内说明为准。",
  },
];